<template>
  <div>
    <base-alert type="warning" dismissible>{{ $t('small_technical_grants_assessments.notify_proposal_deadline') }}</base-alert>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <grant-wizard v-if="GrantForm.initialized" :is-editable="GrantForm.isEditable || (GrantForm.isRevisionEditable && GrantForm.isOnARevisionTab)">
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.general_information_tab')}}</p>
            </template>
            <step-general-informations></step-general-informations>
          </grant-wizard-tab>
          <!-- <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.logical_framework_tab')}}</p>
            </template>
            <step-logical-framework></step-logical-framework>
          </grant-wizard-tab> -->
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-paper"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.document_upload_tab')}}</p>
            </template>
            <step-document-upload></step-document-upload>
          </grant-wizard-tab>
        </grant-wizard>
      </div>
    </div>
  </div>
</template>
<script>
  import StepGeneralInformations from './Steps/GeneralInformations';
  import StepLogicalFramework from './Steps/LogicalFramework';
  import StepDocumentUpload from './Steps/DocumentUpload';

  import {EventBus} from '@/event-bus.js';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab} from 'src/components';
  import {GrantForm} from "@/services";
  import {BaseAlert} from 'src/components';

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      GrantWizard,
      GrantWizardTab,
      BaseAlert,
      StepGeneralInformations,
      StepLogicalFramework,
      StepDocumentUpload,
    },
    created() {
      EventBus.$off('set-active-tab');

      EventBus.$on('wizard-save-progress', data => {
        this.onBeforeSaveProgress(data);
      });

      EventBus.$on('wizard-complete-progress', data => {
        this.onBeforeCompleteProgress(data);
      });
    },
    methods: {
      async onBeforeSaveProgress(data) {
        // let valid = await this.validate();
        // if (valid) {
        //   EventBus.$emit('grant-save-progress', data);
        // }

         EventBus.$emit('grant-save-progress', data);
      },

      async onBeforeCompleteProgress(data) {
        let valid = await this.validate();
        if (!valid) {
          return;
        }

        var submitConfirmation = await this.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {
          EventBus.$emit('grant-complete-progress', data);
        }
      },

      async validate() {
        let valid = true;
        let vm = this;
        let mandatoryFields = [
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__project_title_card_title'),
            value: GrantForm.title
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__lead_applicant_name_card_title'),
            value: GrantForm.model.technical.leadApplicantName
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__region_card_title'),
            value: GrantForm.regionId
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__acp_country_card_title'),
            value: GrantForm.model.technical.acpCountry
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__pa_registration_number_card_title'),
            value: GrantForm.model.technical.paRegistrationNumber
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__pa_supervisory_authority_card_title'),
            value: GrantForm.model.technical.paSupervisoryAuthority
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__duration_card_title'),
            value: GrantForm.model.technical.duration
          },
          {
            translation: vm.$t('medium_grant.technical__1_startdate'),
            value: GrantForm.model.technical.startDate
          },
          {
            translation: vm.$t('medium_grant.technical__1_enddate'),
            value: GrantForm.model.technical.endDate
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__total_annual_budget_card_title'),
            value: GrantForm.model.technical.totalPaAnualBudget
          },
          {
            translation: vm.$t('small_technical_grants_assessments.general_info__total_funding_requested_card_title'),
            value: GrantForm.model.technical.totalFundingRequested
          }

        ];

        let errorFields = [];
        mandatoryFields.forEach(item => {
          if (item.value === undefined || !item.value || (Array.isArray(item.value) && !item.value.length)) {
            errorFields.push(item.translation);
          }
        })

        // New Added - Checks if Mandatory Checkboxes are Checked(At least one checkbox needs to be checked)
        let mandatoryCheckBox = [
          GrantForm.model.technical.typeOfAssessmentIMET,
          GrantForm.model.technical.typeOfAssessmentMETT,
          GrantForm.model.technical.typeOfAssessmentRAPPAM,
          GrantForm.model.technical.typeOfAssessmentIUCN,
          GrantForm.model.technical.typeOfAssessmentEOH,
          GrantForm.model.technical.equivalentAssessment,
          GrantForm.model.technical.typeOfAssessmentSAPA,
          GrantForm.model.technical.typeOfAssessmentSAGE,
          GrantForm.model.technical.typeOfAssessmentGAPA
        ]

        // Returns True Or False
        let isAtLeastOneChecked = mandatoryCheckBox.filter(box => box === true).length > 0;

        if(!isAtLeastOneChecked){
           errorFields.push(vm.$t('small_technical_grants_assessments.type_of__assessment_to_undertake_card_title'));
        }

        if(GrantForm.model.technical.startDate > GrantForm.model.technical.endDate){
          errorFields.push(vm.$t('small_technical_grants_assessments.general_info__date_error'));
        }

        // New Added


        if (errorFields.length) {
          valid = false;
          await this.showNotificationMandatoryFields(errorFields);

          EventBus.$emit('set-active-tab', {
            masterNickname: 'technical',
            masterIndex: 0,
            childIndex: 0,
            validate: true
          });
        }
        return valid;
      },

      showNotificationMandatoryFields(fields) {
        for (var i = 0; i < fields.length; i++) {
          fields[i] = `<p style="margin-top: 8px; color: red; font-size: 15px;">* ${ fields[i]}</p>`;
        }
        let fieldsHtml = '<div style="margin: 20px auto 10px auto; font-size: 14px; text-align: left; max-width: 370px;">' +  fields.join(' ') + '</div>';

        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__mandatory_fields', [fieldsHtml]),
          type: 'warning',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'OK'
        })
      },


      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__pre_submit_application').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: this.$t('general.notification__submit_application'),
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: this.$t('general.notification__cancel_submit_application'),
        })
      }
    }
  };
</script>
